import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button, Flex, Text, Alert, AlertIcon } from "@chakra-ui/react";
import { getWallet } from "../../../../../store/gifts/newWalletSlice";
import GiftWalletModal from "./GiftWalletModal";
import Table from "../../../../shared/table/Table";
import Pagination from "../../../../shared/pagination/Pagination";
import { getAllUsers } from "../../../../../store/allusers/userAllSlice";

const NewWalletGifts = () => {
  const dispatch = useDispatch();
  const wallet = useSelector((s) => s.newWallet);
  const usersAll = useSelector((s) => s.usersAll);

  const [page, setPage] = useState(1);
  const [showGift, setShowGift] = useState(false);

  useEffect(() => {
    dispatch(getWallet({ page }));
  }, [dispatch, page]);

  useEffect(() => {
    // preload owners list
    dispatch(getAllUsers({ page: 1, size: 200, role: "owner" }));
  }, [dispatch]);

  return (
    <>
      {wallet.error && (
        <Alert status="error" mb={4}>
          <AlertIcon />
          {wallet.error}
        </Alert>
      )}

      <Flex mb={4} gap={4}>
        <Button colorScheme="red" onClick={() => setShowGift(true)}>
          Gift Wallet
        </Button>
      </Flex>

      {wallet.data?.length ? (
        <Table>
          <thead>
            <tr>
              <th>#</th>
              <th>Owner</th>
              <th>Amount</th>
              <th>Action</th>
              <th>Date</th>
            </tr>
          </thead>
          <tbody>
            {wallet.data.map((el, i) => (
              <tr key={el._id}>
                <td>{(page - 1) * 10 + (i + 1)}</td>
                <td>{el.owner?.name || "-"}</td>
                <td>{el.amount}</td>
                <td>{el.action}</td>
                <td>{new Date(el.createdAt).toLocaleString()}</td>
              </tr>
            ))}
          </tbody>
        </Table>
      ) : (
        <Flex h="150px" align="center" justify="center">
          <Text color="gray.400">No data</Text>
        </Flex>
      )}

      <Flex justify="flex-end" mt={3}>
        <Pagination
          page={page}
          itemsCount={Number(wallet?.itemsCount) || 0}
          onChange={setPage}
        />
      </Flex>

      {showGift && (
        <GiftWalletModal
          onClose={() => setShowGift(false)}
          onDone={() => {
            setShowGift(false);
            dispatch(getWallet({ page: 1 }));
            setPage(1);
          }}
        />
      )}
    </>
  );
};
export default NewWalletGifts;
